
var StyleLoader = function() {

	this.addStyle = function (filePath){
		if(!isStyleAllreadyAppended(filePath)){ //checks if style appended before. This is defensive approach.
			appendStyleToHead(filePath); //css should be in head	
		}
	}
	
	
	function isStyleAllreadyAppended(filePath) { 
		if (!$("link[href='"+filePath+"']").length)
		    return false;
		return true;
	}
	
	function appendStyleToHead(filePath){
		if(filePath)
			$('<link type="text/css" href="'+filePath+'" rel="stylesheet">').appendTo("head");
	}

	return {
		addStyle : addStyle
	}

}();